export default "__VITE_ASSET__94ee20ef__"